import { z } from "zod";
import { MessageNodeFieldTypeEnum } from "../../../../enum/nodes.enum";
import { useVariableInputStore } from "../../../../store/variableInput.store";
import { stringContainsValidVariable } from "../../../../utils/node.util";

export const messageNodeTextSchema = z.object({
  type: z.literal(MessageNodeFieldTypeEnum.TEXT),
  message: z
    .string()
    .min(1, "Please enter valid message")
    .refine((value) => {
      const validVariables = useVariableInputStore.getState().variables;
      return stringContainsValidVariable(value, validVariables);
    }, "Incorrect variable used"),
});

export type MessageNodeTextSchema = z.infer<typeof messageNodeTextSchema>;
